export default function sleep(timeInMiliseconds: number): Promise<boolean> {
  let timeoutId: NodeJS.Timeout | undefined;

  return new Promise((resolve) => {
    timeoutId = setTimeout(() => {
      clearTimeout(timeoutId);
      resolve(true);
    }, timeInMiliseconds);
  });
}
